import { useAuth } from "../stores/auth";
import { navigationFor } from "../lib/navigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Bare /eex resolves to the first permitted workspace.
export const Route = createFileRoute("/eex/")({
  component: () => <p className="p-6 text-sm text-muted">Choose an available EEX tab.</p>,
  beforeLoad: () => {
    const user = useAuth.getState().user;
    const to = user && navigationFor(user).find(section => section.id === "eex")?.landingTo;
    if (to) throw redirect({ to });
  },
});
